import DataSource from "src/core/data-sources/dataSource";
import EventBus from "src/core/common/eventBus";
import axios from "axios";
import Cache from "src/core/common/cache";
import autoBind from "auto-bind";
import {SideMenuItem} from "../../../../../common/components/collections/menu/sideMenuItems";
import {groupLog} from "src/core/common/logger";

class WPAboutItemsDataSource extends DataSource {
  static cache = new Cache(90000000);
  static PATHNAME = "wp-json/sidebar-nav/store/";
  constructor() {
    super();
    autoBind(this);
  }

  doGet(_) {
    if (this.getCached()) {
      return Promise.resolve(this.getCached());
    } else if (this.contentHost) {
      return axios
        .get(this.contentHost + WPAboutItemsDataSource.PATHNAME)
        .then((response) => {
          const data = response.data.map((d) => new WPSideMenuItem(d));
          WPAboutItemsDataSource.cache.put("", data);
          return data;
        })
        .catch((e) => {
          groupLog("%cWordPress %cInvalid WP about items url", e, "#5097D5");
          return [];
        });
    } else {
      return Promise.resolve([]);
    }
  }

  getEventBus() {
    return eventBus;
  }

  getCached() {
    return WPAboutItemsDataSource.cache.get("");
  }

  setContentHost(host) {
    this.contentHost = host;
  }
}

class WPSideMenuItem extends SideMenuItem {
  get label() {
    return this.obj.title;
  }
  get linkTo() {
    return this.obj.url;
  }
  get external() {
    return true;
  }
  get requiresAuthentication() {
    return false;
  }
  get requiresDelivery() {
    return false;
  }
}

const eventBus = new EventBus();

export default WPAboutItemsDataSource;
